module.exports = ".video-container {\n  width: 100%;\n  height: 0;\n  padding-top: 56.25%;\n  position: relative;\n  background: black; }\n  .video-container vg-player {\n    position: static;\n    transition: opacity 0.3s ease-out;\n    opacity: 1; }\n  .video-container video {\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    position: absolute; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/video-player/micro-video-player.style.scss
// module id = 786
// module chunks = 2